import React, { useState } from 'react';
import { Box, BoxExtendedProps } from '@common-fe/common-fe';

import { Roles } from '@/common/constants';
import { useHasAccess } from '@/modules/core/hooks';
import { CardReplaceModal } from '@/modules/transaction/components/Cards/components/CardReplaceModal/CardReplaceModal.tsx';
import { ReplacementInitiationType } from '@/modules/transaction/components/Cards/components/CardReplaceModal/hooks/useCardReplacement.query';
import useCardReplaceModalStore from '@/modules/transaction/components/Cards/store/useCardReplaceModal.store';
import { useGetCardsQuery } from '@/modules/transaction/queries/useGetCards.query';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

import VerifyMyCardModal from './components/VerifyMyCardModal';
import CompleteBanner from './CompleteBanner';

const CompleteVerificationMessage: React.FC<BoxExtendedProps> = (props) => {
  const { employee } = useEmployeeStore();
  const {
    state: { modalVisible: isCompleteBannerModalVisible, cardholderName },
    handleChangeVisibility,
  } = useCardReplaceModalStore();
 
  const { refetch } = useGetCardsQuery(employee?.id); 
  const [isVerifyMyCardModalVisible, setIsVerifyMyCardModalVisible] = useState(false);
  const isLimitedAccess = useHasAccess([
    {
      role: Roles.employeeLimitedAccess,
    },
  ]);

  if(!isLimitedAccess) {
    return null;
  }
  
  return (
    <Box {...props}>
      {isVerifyMyCardModalVisible
        ? (
          <VerifyMyCardModal
            onSetVisible={setIsVerifyMyCardModalVisible}
            refreshCardList={refetch}
          />
        )
        : (
          <CardReplaceModal
            visible={isCompleteBannerModalVisible}
            cardholderName={cardholderName}
            onSetVisible={handleChangeVisibility}
            refreshCardList={refetch}
            replacementInitiationType={ReplacementInitiationType.BANNER}
          />
        )}

      <CompleteBanner
        isWarningMode
        handleOpenModal={() => setIsVerifyMyCardModalVisible(true)}
      /> 
    </Box>
  );
};

export default CompleteVerificationMessage;
